//deps
import { useCallback, useContext, useState } from "react";

// internal-deps
import { AnalyticsContext } from "@swiggy-private/checkout-core";

//helpers
import { getFrequencyCapValue, updateFrequencyCapValue } from "@payment-client/helpers/Storage";

// interfaces
import { IAppStorageData } from "@payment-client/interfaces/Storage";

// constants
import { APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER } from "@payment-client/constants/StorageKeys";

// analytics
import { onInAppUpiHalfCard, onInAppUpiHalfCardClose } from "@payment-client/analytics/events/InAppUpi";

export interface UseInAppUpiHalfCardReturnType {
    showHalfCard: boolean;
    setShowHalfCard: (value: boolean) => void;
    closeHalfCard: VoidFunction;
    onHalfCardLoad: VoidFunction;
    getOneTapHalfCardFromAppStorage: () => Promise<IAppStorageData>;
}
export const useInAppUpiHalfCard = (): UseInAppUpiHalfCardReturnType => {
    const [showInAppUpiHalfCard, setShowInAppUpiHalfcard] = useState(false);
    const { impressionEvent, clickEvent } = useContext(AnalyticsContext);
    const [inAppUpiHalfCardStorageData, setInAppUpiHalfCardStorageData] = useState<IAppStorageData>({
        [APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER.INAPP_UPI_HALF_CARD_COUNT]: "0",
    });

    const getOneTapHalfCardFromAppStorage = useCallback(async () => {
        const _oneTapHalfCardStorageData = await getFrequencyCapValue(
            APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER.INAPP_UPI_HALF_CARD_COUNT,
        );

        if (_oneTapHalfCardStorageData != null) {
            setInAppUpiHalfCardStorageData(_oneTapHalfCardStorageData);
            return _oneTapHalfCardStorageData;
        }

        return { [APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER.INAPP_UPI_HALF_CARD_COUNT]: "0" };
    }, []);

    const onHalfCardLoad = useCallback(() => {
        onInAppUpiHalfCard(impressionEvent);
        // update app storage count
        updateFrequencyCapValue(
            inAppUpiHalfCardStorageData,
            APP_STORAGE_KEYS_FOR_INAPP_UPI_BANNER.INAPP_UPI_HALF_CARD_COUNT,
        );
    }, [impressionEvent, inAppUpiHalfCardStorageData]);

    const closeHalfCard = useCallback(() => {
        onInAppUpiHalfCardClose(clickEvent);
        setShowInAppUpiHalfcard(false);
    }, [clickEvent]);
    return {
        showHalfCard: showInAppUpiHalfCard,
        setShowHalfCard: setShowInAppUpiHalfcard,
        getOneTapHalfCardFromAppStorage,
        closeHalfCard,
        onHalfCardLoad,
    };
};
